
<modal
  title="Edit Pending Sale"
  size="side"
  :open="open"
  @close="closeModal"
>
  <div class="description">
    {{ pendingSale.title }}
  </div>
  <p><span>Price:</span> <b>{{ $filters.currency(pendingSale.price, { full: true }) }}</b></p>

  <card-search
    include-hidden
    placeholder="Assign to a different card"
    @select="setLadderCard"
  />

  <p v-if="switchingCard">
    Switching the card to: {{ switchingCard }}
  </p>

  <date-input
    v-model="pendingSale.date"
    label="Date"
  />

  <select-input
    v-model="pendingSale.platform"
    label="Platform"
    :options="platformOptions"
  />

  <select-input
    v-model="pendingSale.listingType"
    label="Listing Type"
    :options="listingTypeOptions"
  />

  <select-input
    v-model="pendingSale.employee"
    label="Employee"
    :options="employeeOptions"
  />

  <text-area-input
    v-model="pendingSale.employeeNotes"
    label="Employee Notes"
  />

  <template #footer>
    <align small-gap>
      <btn
        :loading="submitting"
        loading-text="Submitting"
        @click="submit"
      >
        Submit
      </btn>

      <btn kind="secondary" @click="closeModal">
        Cancel
      </btn>
    </align>
  </template>
</modal>
